export const Colors = {
  /* * Before */
  themeColorBefore: "#203cc5",
  themeColorSmallBefore: "#2f4cdd",
  addDealButtonBefore: "#2f4cdd",
  addDealButtonHoverBackgroundBefore: "#203cc5",
  addDealButtonHoverBorderBefore: "#1e38bb",
  /* * After */
  themeColorAfter: "#4e36a8",
  themeColorSmallAfter: "#5e42c2",
  addDealButtonAfter: "#4e36a8",
  buttonLightAfter: "#6a56b1",
  addDealButtonHoverBackgroundAfter: "#4a339e",
  addDealButtonHoverBorderAfter: "#4e36a8",
};
